import React, { type FC, type PropsWithChildren } from 'react'

import styled from '@emotion/styled'

type FormContainerProps = PropsWithChildren<{
  disabled?: boolean
  canSubmit?: boolean
  onSubmit: React.FormEventHandler
}>

const StyledSubmitInput: any = styled.input`
  display: none;
`

const FormContainer: FC<FormContainerProps> = (
  { disabled, canSubmit, onSubmit, children } = {
    disabled: false,
    canSubmit: true,
    onSubmit: (): void => {},
  },
) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault()

    if (canSubmit === true) {
      onSubmit(e)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <StyledSubmitInput type="submit" />
      <fieldset disabled={disabled}>{children}</fieldset>
    </form>
  )
}

export default FormContainer
